import { Component } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { showAlert } from "src/app/utils/alert";
import { AuthService } from "../../services/auth.service";

@Component({
	selector: 'app-reset-password',
	templateUrl: './reset-password.component.html',
	styleUrls: ['./reset-password.component.scss'],
})
export class ResetPasswordComponent {
	fromLoginMessage: string | null = null;
	errorMessage: string | null = null;
	loading: boolean = false;
	form: FormGroup = new FormGroup({
		email: this._formBuilder.control('', [Validators.required, Validators.email]),
	});

	get emailField() {
		return this.form.controls['email'];
	}

	constructor(
		private _formBuilder: FormBuilder,
		private _router: Router,
		private _authService: AuthService,
	) {
		const email = this._router.getCurrentNavigation()?.extras.state?.['email'];
		const fromLogin = this._router.getCurrentNavigation()?.extras.state?.['fromLogin'];
		if (email) {
			this.form.patchValue({ email });
		}
		if (fromLogin) {
			this.fromLoginMessage = 'Para acceder debes restablecer tu contraseña.';
		}
	}

	showSuccessMessage() {
		showAlert('Ha sido enviado el enlace de recuperación al correo registrado.', undefined, 'success');
	}

	showErrorMessage() {
		showAlert('El enlace de recuperación no pudo ser enviado al correo electrónico registrado. Si el problema persiste, comuníquese con el administrador del sistema.', undefined, 'error');
	}

	onSubmit(){
		if (this.form.valid) {
			this.loading = true;
			this._authService
				.resetPassword(this.form.value.email)
				.subscribe({
					next: async (data) => {
						this.loading = false;
						if(data.success){
							this.showSuccessMessage();
						}else{
							this.showErrorMessage();
						}
					},
					error: () => {
						this.loading = false;
						this.showErrorMessage();
					}
				});
		}
	}

	navigateToLogin(){
		this._router.navigate(['/auth/login']);
	}
}